var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 12.4H17.55V11.65H16.8V12.4ZM16.05 12.4C16.05 14.4158 14.4158 16.05 12.4 16.05V17.55C15.2443 17.55 17.55 15.2443 17.55 12.4H16.05ZM12.4 16.05C10.3842 16.05 8.75 14.4158 8.75 12.4H7.25C7.25 15.2443 9.55573 17.55 12.4 17.55V16.05ZM8.75 12.4C8.75 10.3842 10.3842 8.75 12.4 8.75V7.25C9.55573 7.25 7.25 9.55573 7.25 12.4H8.75ZM16.8 11.65H12.95V13.15H16.8V11.65Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0159 9.85451C14.3519 9.1723 13.4259 8.75 12.4 8.75V7.25C13.8472 7.25 15.1561 7.84794 16.0908 8.8083L15.0159 9.85451Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleNew);
export default __webpack_public_path__ + "static/media/GoogleNew.0ea4b9d0.svg";
export { ForwardRef as ReactComponent };